import {IThemeIcons} from '../architecture/sections/theme-icons.interface';
import {InfoIcon} from './icons/info.icon';
import { AddIcon } from './icons/add.icon';
import { BackIcon } from './icons/back.icon';
import { ForwardIcon } from './icons/forward.icon';
import { CloseIcon } from './icons/close.icon';
import { SafeZoneIcon } from './icons/safe-zone.icon';
import { HelpIcon } from './icons/help.icon';
import { TwoCharsIcon } from './icons/two-chars.icon';
import { EarthGlobeIcon } from './icons/earth-globe.icon';
import { TopGamesIcon } from './icons/live-arena-navbar/top-games.icon';
import { RouletteIcon } from './icons/live-arena-navbar/roulette.icon';
import { BlackjackIcon } from './icons/live-arena-navbar/blackjack.icon';
import { EliteLoungeIcon } from './icons/live-arena-navbar/elite-lounge.icon';
import { PokerIcon } from './icons/live-arena-navbar/poker.icon';
import { BaccaratIcon } from './icons/live-arena-navbar/baccarat.icon';
import { GameShowsIcon } from './icons/live-arena-navbar/game-shows.icon';
import { NewGamesIcon } from './icons/live-arena-navbar/new-games.icon';
import {LinkToOfferIcon} from "./icons/link-to-offer.icon";
import {LinkToOfferCloseIcon} from "./icons/link-to-offer-close.icon";
import {SourceOfFundsIcon} from "./icons/source-of-funds.icon";
import {ArrowsUpDownIcon} from "./icons/arrows-up-down.icon";
import {MegaphoneIcon} from "./icons/megaphone.icon";
import {ChipIcon} from "./icons/chip.icon";
import {SettingsIcon} from "./icons/settings.icon";
import {MuteIcon} from "./icons/live-arena-tile/mute.icon";
import {UnmuteIcon} from "./icons/live-arena-tile/unmute.icon";
import {ViewersIcon} from "./icons/live-arena-tile/viewers.icon";
import {BrokenLinkIcon} from "./icons/live-arena-tile/broken-link.icon";
import {TimeReminderIcon} from "./icons/time-reminder.icon";

export const ThemeDefaultIcons: IThemeIcons = {
    addIcon: AddIcon,
    infoIcon: InfoIcon,
    backIcon: BackIcon,
    forwardIcon: ForwardIcon,
    closeIcon: CloseIcon,
    safeZoneIcon: SafeZoneIcon,
    helpIcon: HelpIcon,
    twoCharsIcon: TwoCharsIcon,
    earthGlobeIcon: EarthGlobeIcon,
    topGamesIcon: TopGamesIcon,
    rouletteIcon: RouletteIcon,
    blackjackIcon: BlackjackIcon,
    eliteLoungeIcon: EliteLoungeIcon,
    pokerIcon: PokerIcon,
    baccaratIcon: BaccaratIcon,
    gameShowsIcon: GameShowsIcon,
    newGamesIcon: NewGamesIcon,
    linkToOfferIcon: LinkToOfferIcon,
    linkToOfferCloseIcon: LinkToOfferCloseIcon,
    sourceOfFundsIcon: SourceOfFundsIcon,
    arrowsUpDownIcon: ArrowsUpDownIcon,
    megaphoneIcon: MegaphoneIcon,
    chipIcon: ChipIcon,
    settingsIcon: SettingsIcon,
    muteIcon: MuteIcon,
    unmuteIcon: UnmuteIcon,
    viewersIcon: ViewersIcon,
    brokenLinkIcon: BrokenLinkIcon,
    timeSpentReminderClockIcon: TimeReminderIcon
};
